"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStore = void 0;
var redux_1 = require("redux");
var redux_saga_1 = require("redux-saga");
var redux_devtools_extension_1 = require("redux-devtools-extension");
var pageMap_1 = require("@/rendering/common/pageMap");
exports.getStore = function (page, clientSide) {
    var reducer = pageMap_1.pageMap[page].reducer;
    var saga = pageMap_1.pageMap[page].saga;
    var store;
    if (clientSide) {
        var sagaMiddleware = redux_saga_1.default();
        var middlewares = process.env.NODE_ENV !== 'production'
            ? redux_devtools_extension_1.composeWithDevTools(redux_1.applyMiddleware(sagaMiddleware))
            : redux_1.applyMiddleware(sagaMiddleware);
        store = redux_1.createStore(reducer, window.REDUX_DATA, middlewares);
        if (saga)
            sagaMiddleware.run(saga);
        return store;
    }
    store = redux_1.createStore(reducer);
    return store;
};
